const DEFAULT_NAVIGATION_STATE = {
    page: 'futures',
    futuresMode: 'up-down'
};
export const FUTURES_MODE_LABELS = {
    'up-down': 'Up Down',
};
const FUTURES_MODE_DESCRIPTIONS = {
    'up-down': 'Predict if price movement will finish up or down by expiry',
};
export function getFuturesModeDescription(mode) {
    return FUTURES_MODE_DESCRIPTIONS[mode];
}
export function buildPath(state) {
    if (state.page === 'futures') {
        return `/futures/${state.futuresMode}`;
    }
    return `/${state.page}`;
}
export function getNavigationStateFromPath(pathname) {
    const normalizedPath = pathname.trim().toLowerCase();
    const segments = normalizedPath.split('/').filter(Boolean);
    if (segments.length === 0) {
        return DEFAULT_NAVIGATION_STATE;
    }
    const [firstSegment, secondSegment] = segments;
    if (firstSegment === 'futures') {
        if (secondSegment === 'up-down') {
            return {
                page: 'futures',
                futuresMode: secondSegment
            };
        }
        return DEFAULT_NAVIGATION_STATE;
    }
    if (firstSegment === 'positions') {
        return {
            page: 'positions',
            futuresMode: DEFAULT_NAVIGATION_STATE.futuresMode
        };
    }
    if (firstSegment === 'history') {
        return {
            page: 'history',
            futuresMode: DEFAULT_NAVIGATION_STATE.futuresMode
        };
    }
    if (firstSegment === 'leaderboard') {
        return {
            page: 'leaderboard',
            futuresMode: DEFAULT_NAVIGATION_STATE.futuresMode
        };
    }
    if (firstSegment === 'settings') {
        return {
            page: 'settings',
            futuresMode: DEFAULT_NAVIGATION_STATE.futuresMode
        };
    }
    if (firstSegment === 'deposit') {
        return {
            page: 'deposit',
            futuresMode: DEFAULT_NAVIGATION_STATE.futuresMode
        };
    }
    if (firstSegment === 'withdraw') {
        return {
            page: 'withdraw',
            futuresMode: DEFAULT_NAVIGATION_STATE.futuresMode
        };
    }
    if (firstSegment === 'support') {
        return {
            page: 'support',
            futuresMode: DEFAULT_NAVIGATION_STATE.futuresMode
        };
    }

      if (firstSegment === "dashboard") {
        return {
          page: "dashboard",
          futuresMode: DEFAULT_NAVIGATION_STATE.futuresMode,
        };
      }
        if (firstSegment === "spin-wheel") {
    return {
      page: "spin-wheel",
      futuresMode: DEFAULT_NAVIGATION_STATE.futuresMode,
    };
  }
    if (firstSegment === 'layout') {
        return {
            page: 'layout',
            futuresMode: DEFAULT_NAVIGATION_STATE.futuresMode
        };
    }
    return DEFAULT_NAVIGATION_STATE;
}


 
